import { passwordRequirements } from '@emazy/shared-validation';

export function PasswordRequirements({ password }: { password: string }) {
  return (
    <div className="password-requirements" aria-label="Password requirements">
      <p>Your password needs:</p>
      <ul>
        {passwordRequirements.map((requirement) => {
          const met = requirement.test(password);
          return (
            <li className={met ? 'is-met' : ''} key={requirement.id}>
              <i className={met ? 'pi pi-check-circle' : 'pi pi-circle'} aria-hidden="true" />
              <span>
                {requirement.label}: {met ? 'met' : 'not met'}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
